import { ChangeEvent, FC, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Grid, Paper, Tab, Tabs } from '@material-ui/core';
import { useStylesSecond } from './styles';
import TabPanel from 'components/TabPanel';
import { ZoomInfoTable } from './ZoomInfoTable';
import { ZoomSyncUser } from './ZoomSyncUser';
import { ZoomSyncGroup } from './ZoomSyncGroup';
import { useLocation } from 'react-router-dom';
import AppTimeline from '../GoogleTable/AppTimeline';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
function useQuer() {
  return new URLSearchParams(useLocation().search);
}
export const ZoomTable: FC = observer(() => {
  const classes = useStylesSecond();
  function a11yProps(index: string) {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  }
  const {
    ldapStore: { getGoogleTimeline },
    notificationStore: { openNotification },
  } = useStore();
  const query = useQuer();
  const queryValue = query.get('value');
  const defaultTabs = (Array.isArray(queryValue) ? queryValue[0] : queryValue) ?? 'one';
  const [value, setValue] = useState<string>(defaultTabs);

  const handleChange = (event: ChangeEvent<unknown>, newValue: string) => {
    setValue(newValue);
  };

  const zoomtimelineReq = useQuery(['zoomTimeline', 'apps'], () => getGoogleTimeline('zoom'), {
    enabled: value === 'four',
    onError: () => {
      openNotification('error', "Can't get zoom timeline");
    },
  });
  return (
    <Grid item xl className={classes.tabsPanel}>
      <Paper className={classes.tabsPaper}>
        <Tabs
          value={value}
          className={classes.tabs}
          TabIndicatorProps={{ style: { color: 'transparent', background: 'transparent' } }}
          onChange={handleChange}
        >
          <Tab value='one' wrapped label={<span>INFO</span>} {...a11yProps('one')} className={classes.label} />
          <Tab value='two' wrapped label={<span>Users</span>} {...a11yProps('two')} className={classes.label} />
          <Tab value='three' wrapped label={<span>Groups</span>} {...a11yProps('three')} className={classes.label} />
          <Tab value='four' wrapped label={<span>Timeline</span>} {...a11yProps('three')} className={classes.label} />
        </Tabs>
        <div className={classes.tabBox}>
          <TabPanel value={value} index='one'>
            <ZoomInfoTable />
          </TabPanel>
          <TabPanel value={value} index='two'>
            <ZoomSyncUser />
          </TabPanel>
          <TabPanel value={value} index='three'>
            <ZoomSyncGroup />
          </TabPanel>
          <TabPanel value={value} index='four'>
            <AppTimeline header='user' events={zoomtimelineReq.data || []} loading={zoomtimelineReq.isLoading} />
          </TabPanel>
        </div>
      </Paper>
    </Grid>
  );
});
